import React, { Fragment, useState, useEffect } from 'react';
import { below } from 'src/components/global/mediaqueries';
import CartContext from 'src/libs/BergCommerceAPI/Basket/Context/Cart';
import CookieConsentBanner from 'src/components/CookieConsent';
import fonts from 'src/assets/fonts/fonts';
import Footer from 'src/components/Footer';
import Header from 'src/components/Header';
import ItemCount from 'src/libs/BergCommerceAPI/Basket/ItemCount';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import header from 'src/cache/header';
import footer from 'src/cache/footer';
import Seo from './Seo';

const AppStyles = styled(Fragment)`
    ${fonts};
    * {
        box-sizing: border-box;
    }
`;

const ModuleContainer = styled('div')`
    min-height: 90vh;
    animation: fadein 1s;

    ${below.tablet_s} {
        //This exists due to search input field is always visible in mobile mode
        padding-top: 50px;
    }

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const Layout = ({ children, title, metaTitle, options, seo }) => {
    const [cart, setCart] = useState({
        count: 0,
    });

    useEffect(() => {
        const fetchCartCount = async () => {
            setCart({
                count: await ItemCount(),
            });
        };
        fetchCartCount();
    }, []);

    return (
        <CartContext.Provider value={{ cart, setCart }}>
            <AppStyles>
                <Header data={header} siteTitle="Berg Insight" />
                {seo && <Seo {...seo} />}
                <ModuleContainer id="modulecontainer">
                    <div className="mainContent">{children}</div>
                </ModuleContainer>
                <Footer data={footer} />
                <CookieConsentBanner data={options.cookieSettings} />
            </AppStyles>
        </CartContext.Provider>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    metaTitle: PropTypes.string,
    options: PropTypes.object,
    title: PropTypes.string,
    seo: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.string,
        url: PropTypes.string,
        type: PropTypes.string,
    }),
};

Layout.defaultProps = {
    metaTitle: '',
    options: {},
    title: '',
};

export default Layout;
